import React, { useState } from 'react';

const EdgeLabelWithEdit = ({ label, onChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedLabel, setEditedLabel] = useState(label);

  const handleSubmit = (e) => {
    e.preventDefault();
    onChange(editedLabel);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        <form 
          onSubmit={handleSubmit}
          onClick={e => e.stopPropagation()}
          className="dialog-edge-editor"
        >
          <input
            type="text"
            value={editedLabel}
            onChange={e => setEditedLabel(e.target.value)}
            className="app-field w-full px-3 py-2 text-sm"
            autoFocus
            onBlur={handleSubmit}
          />
        </form>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="dialog-edge-label group">
        <span>{label}</span>
        <button
          className="dialog-edge-edit-button"
          aria-label="Edit edge label"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsEditing(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            className="w-3.5 h-3.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default EdgeLabelWithEdit; 
